import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
  style?: object;
};
function ArrowLeftMedium({
  size = 16,
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color} style={style}><path d="M6.828 11H21v2H6.828l5.364 5.364-1.414 1.414L3 12l7.778-7.778 1.414 1.414L6.828 11z"  /></Svg>;
}
export default ArrowLeftMedium;